/** As this grows, we may need to split it into multiple files. */

export const SUPPORT_EMAIL_HREF = 'mailto:contact@brightlocal.com';
